import Notification from '@rio-cloud/rio-uikit/lib/es/Notification';
import { FormattedMessage } from 'react-intl';

export const copyToClipboard = (text: string, showText: boolean) => {
    // create temporary element
    const el = document.createElement('textarea');
    // assign text
    el.value = text;
    // set element readonly
    el.setAttribute('readonly', '');
    // el.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(el);
    // select text
    el.select();
    // copy selected text
    document.execCommand('copy');
    // remove selected element
    document.body.removeChild(el);

    Notification.success(
        [
            // eslint-disable-next-line react/jsx-key
            <FormattedMessage id="intl-msg:coreconAdminWeb.copiedToClipboard"/>,
            // eslint-disable-next-line react/jsx-key
            <span className="padding-5">{showText && text}</span>
        ]
    );
};

export const truncate = (input: string, amount: number) =>
    input?.length > amount ? `${input.substring(0, amount - 3)}...` : input;

export const unionBy = (array1: any[] = [], array2: any[] = [], key: string) => {
    const map = new Map(array1.concat(array2).map(item => [item[key], item]));
    return Array.from(map.values());
};

export const deepMerge = (target: any, source: any) => {
    if (target == null) target = {}; // Initialize target if null/undefined

    const result = { ...target }; // Create a shallow copy of the target

    for (const key of Object.keys(source)) {
        const sourceValue = source[key];
        const targetValue = result[key];

        // If the value is an object, merge recursively
        if (sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue)) {
            result[key] = deepMerge(
                targetValue && typeof targetValue === 'object' ? targetValue : {},
                sourceValue
            );
        }
        // If the value in source is null or undefined, keep the target value (if it exists)
        else if (sourceValue == null) {
            if (targetValue !== undefined && targetValue !== null) {
                result[key] = targetValue; // Keep target value
            } else {
                result[key] = sourceValue; // Use null/undefined only if it's the only option
            }
        }
        // Otherwise, assign the value from source (if it has a meaningful value)
        else {
            result[key] = sourceValue;
        }
    }

    return result;
};

export enum SortDirection {
    ASCENDING = 'asc',
    DESCENDING = 'desc',
}